import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';
import { updateUserStreak } from '../services/streakService';

// Custom hook to track daily app visits for streak calculation
export const useAppVisitTracker = (onStreakUpdate) => {
  const { currentUser } = useAuth();

  useEffect(() => {
    const trackVisit = async () => {
      if (!currentUser) return;

      try {
        // Check if we've already tracked a visit today
        const today = new Date().toDateString();
        const lastVisitKey = `lastVisit_${currentUser.uid}`;
        const lastVisit = localStorage.getItem(lastVisitKey);

        if (lastVisit !== today) {
          // Track the visit and update streak
          const streakResult = await updateUserStreak(currentUser.uid);
          
          // Store today's visit in localStorage to avoid multiple calls
          localStorage.setItem(lastVisitKey, today);
          
          // Trigger modal callback with streak data
          if (onStreakUpdate && streakResult) {
            onStreakUpdate(streakResult);
          }
        }
      } catch (error) {
        console.error('Error tracking app visit:', error);
      }
    };

    // Track visit when user is authenticated
    if (currentUser) {
      trackVisit();
    }
  }, [currentUser, onStreakUpdate]);
};

export default useAppVisitTracker;